import { IEventFeedResponse, ITopLeagueFeedResponse } from "@finbackoffice/websocket-client";
import { FC, useContext, useEffect } from "react";
import classNames from "classnames";
import { useCollapseMargin, useSportsbookConfig } from "@finbackoffice/site-core";
import { SportsbookGameItemTypeEnum } from "@finbackoffice/fe-core";
import { Svg } from "components/base/svg/Svg";
import { PrematchContext } from "contexts";
import PrematchTournamentGame from "../game/PrematchTournamentGame";
import styles from "./prematch-tournament-flex.module.sass";

type Props = {
    tournament: ITopLeagueFeedResponse;
    isOpenedByDefault: boolean;
    games: IEventFeedResponse[];
    isFirst: boolean;
};

const PrematchTournamentFlex: FC<Props> = ({ isOpenedByDefault, games, tournament, isFirst }) => {
    const { opened, animating, headerRef, containerRef } = useCollapseMargin(isOpenedByDefault);
    const { setActiveGameId } = useContext(PrematchContext);
    const sportsbookConfig = useSportsbookConfig();

    useEffect(() => {
        const shouldSetGameId: boolean = isFirst && Boolean(games.length);

        if (shouldSetGameId) {
            setActiveGameId(games[0].id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [games, isFirst]);

    return (
        <li
            className={classNames(styles.item, {
                [styles.opened]: opened,
                [styles.isFavVariant]: true,
            })}>
            <div className={styles.header} ref={headerRef}>
                <Svg
                    src="/common/desktop/base-icons/arrow-white.svg"
                    width={10}
                    height={5}
                    wrapper="span"
                    className={styles.arrow}
                />
                <span className={styles.name}>
                    <span>{tournament?.name}</span>
                    {tournament?.category_name ? ` / ${tournament?.category_name}` : ""}
                </span>
                {tournament.is_top && (
                    <Svg
                        src="/common/desktop/base-icons/top-leagues.svg"
                        wrapper="span"
                        className="svg-icon"
                    />
                )}
                <span className={styles.gameCount}>{tournament?.games_count}</span>
            </div>
            {!!games?.length && (opened || animating) && (
                <div ref={containerRef} className={classNames(styles.content)}>
                    {games.map((game) => (
                        <PrematchTournamentGame
                            game={game}
                            key={game.id}
                            layout={
                                sportsbookConfig.gameItem === SportsbookGameItemTypeEnum.Flex
                                    ? SportsbookGameItemTypeEnum.Flex
                                    : SportsbookGameItemTypeEnum.Default
                            }
                        />
                    ))}
                </div>
            )}
        </li>
    );
};

export default PrematchTournamentFlex;
